import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import Vuetify from "vuetify";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate";
import {
  EMIT_ACTION_PLAN_TEMPLATE_EVENTS,
  LABELS_ADD_ACTIONPLAN_FORM,
  LABELS_DATATYPE,
  WHITE_COLOR
} from "../../../constants/TemplatePdfConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  FORM_CONSTANTS,
  FORM_VALIDATORS,
  ICON_LIST_FIXED
} from "@/shared/constants/FormConstants";
import { PdfTemplateSection } from "@/modules/TemplatePdf/Models/sectionsPdf";
import { FORM_TEMP_CONSTANTS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { ADD_TOOLTIP } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { Icon } from "@/shared/models/Icon";
import _ from "lodash";

Vue.use(Vuetify);
@Component({
  name: "AddSectionActionPlan",
  components: {
    ModalTemplate
  }
})
export default class AddSectionActionPlan extends Vue {
  @Prop() preloadSection?: PdfTemplateSection;
  @Prop() isModal!: boolean;
  @Prop() renderComponent!: boolean;
  @Prop() cleanComponent!: boolean;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];
  LABEL_DATATYPE = LABELS_DATATYPE;
  ADD_LABEL_TITLE = LABELS_ADD_ACTIONPLAN_FORM;
  CANCEL = FORM_CONSTANTS.BUTTON.CANCEL;
  SAVE_BTN = FORM_CONSTANTS.BUTTON.SAVE;
  ADD_FIELD_BTN = FORM_TEMP_CONSTANTS.BUTTON.ADD_FIELD;
  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  primaryBtnClassRound = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  btnClassTertiary = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  terBtnClass = STYLE_CLASSES.TERTIARY_BTN;
  ADD_TOOLTIP = ADD_TOOLTIP;
  iconsList: Icon[] = ICON_LIST_FIXED;

  validSection = false;
  addNewSection = true;
  showColorPickerMain = false;
  showColorPickerWarning = false;
  tempSection: PdfTemplateSection = {
    title: "",
    mainColor: "",
    recomendationColor: "",
    labels: [
      {
        title: "",
        valueType: ""
      },
      {
        title: "",
        valueType: ""
      }
    ],
    isRange: false,
    recomendationIcon: ""
  };
  @Watch("preloadSection")
  loadEditingInfo() {
    if (this.preloadSection && this.preloadSection.title !== "") {
      this.tempSection = _.cloneDeep(this.preloadSection);
    }
  }

  @Watch("cleanComponent")
  cancelOption(clickClean?: boolean) {
    if (this.cleanComponent || clickClean) {
      this.tempSection = {
        title: "",
        mainColor: "",
        recomendationColor: "",
        labels: [
          {
            title: "",
            valueType: ""
          },
          {
            title: "",
            valueType: ""
          }
        ],
        isRange: false,
        recomendationIcon: ""
      };
      this.$emit(EMIT_ACTION_PLAN_TEMPLATE_EVENTS.CLOSE);
    }
  }
  addNewField() {
    if (this.validSection) {
      this.tempSection.mainColor == ""
        ? (this.tempSection.mainColor = WHITE_COLOR)
        : this.tempSection.mainColor;
      this.tempSection.recomendationColor == ""
        ? (this.tempSection.recomendationColor = WHITE_COLOR)
        : this.tempSection.recomendationColor;
      this.$emit(EMIT_ACTION_PLAN_TEMPLATE_EVENTS.ADD_SECTION, {
        ...this.tempSection
      });
    }
  }
}
